import { render, staticRenderFns } from "./section-showrooms.vue?vue&type=template&id=1f6c6ca4&scoped=true&"
var script = {}
import style0 from "./section-showrooms.vue?vue&type=style&index=0&id=1f6c6ca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6c6ca4",
  null
  
)

export default component.exports